import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { TbSubscript } from "react-icons/tb";
import { twMerge } from "tailwind-merge";
import { useTextEditorContext } from "../../hooks/useTextEditorContext";
import { activeButtonStyleHiddenOnMobile, buttonStyleHiddenOnMobile } from "./TextEditorMenuStyle";

export interface TextEditorMenuButtonSubscriptProps {
  className?: string;
  children?: React.ReactNode;
}

export const TextEditorMenuButtonSubscript = ({ className, children }: TextEditorMenuButtonSubscriptProps) => {
  const { t } = useTranslation("textEditor");
  const { editor, disabled } = useTextEditorContext();

  const buttonClassName =
    editor && editor.isActive("subscript") ? activeButtonStyleHiddenOnMobile : buttonStyleHiddenOnMobile;

  return (
    <Tooltip content={t("buttons.subscript")}>
      <button
        type="button"
        onClick={() => {
          if (editor) {
            editor.chain().focus().toggleSubscript().run();
          }
        }}
        className={twMerge(buttonClassName, className)}
        disabled={disabled}
      >
        {children ?? <TbSubscript className="h-6 w-6" />}
      </button>
    </Tooltip>
  );
};
